import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { AutomationPopupState } from 'src/components/AutomationTrading/AutomationPopup/AutomationPopup.state';
import {
    AutomationPopupContainer,
    AutomationPopupControlsContainer,
    AutomationPopupHeader,
    EventDetails,
    EventsWrapper,
    EventWrapper,
} from 'src/components/AutomationTrading/AutomationPopup/AutomationPopup.style';
import { Button } from 'src/domains/layouts/shared/buttons/Button';
import { AutotraderLogsErrorKind } from 'src/components/AutomationTrading/AutomationItem/HistoryItem';

function buildEventLink(eventId: number): string {
    return `/trading?*events=${eventId}`;
}
function getLogInfo(log: AutotraderLogsErrorKind): string {
    const kind = log.kind;

    switch (kind) {
        case 'error':
            return `Error: ${log.error}`;
        case 'events':
            return `Events: ${log.events}`;
        case 'traceId':
            return `TraceId: ${log.traceId}`;
        case 'finished':
            return `Finished: ${log.finished}`;
        case 'started':
            return `Started: ${log.started}`;
        case 'markets':
            return `Markets: ${log.markets}`;
        default:
            return 'Unknown';
    }
}
type AutomationPopupPropsType = {
    popupState: AutomationPopupState;
};
export const AutomationPopup = observer('AutomationPopup', (props: AutomationPopupPropsType) => {
    if (props.popupState.isOpen === null) {
        return null;
    }

    if (props.popupState.isOpen.type === 'logs') {
        return (
            <AutomationPopupContainer>
                <AutomationPopupHeader>
                    <h2>Error logs details</h2>
                </AutomationPopupHeader>
                <EventsWrapper>
                    {props.popupState.isOpen.data.map((log, index) => (
                        <EventWrapper key={`${index}-log}`}>
                            <EventDetails>{getLogInfo(log)}</EventDetails>
                        </EventWrapper>
                    ))}
                </EventsWrapper>
                <AutomationPopupControlsContainer>
                    <Button
                        size='regular'
                        onClick={props.popupState.close}
                    >
                        Close
                    </Button>
                </AutomationPopupControlsContainer>
            </AutomationPopupContainer>
        );
    }

    return (
        <AutomationPopupContainer>
            <AutomationPopupHeader>
                <h2>History events details: {props.popupState.isOpen.data.length} events</h2>
            </AutomationPopupHeader>
            <EventsWrapper>
                {props.popupState.isOpen.data.map((event, index) => {
                    return (
                        <EventWrapper key={`${index}-${event.id}`}>
                            <EventDetails>No: {index + 1}</EventDetails>
                            <EventDetails>
                                <a
                                    href={buildEventLink(event.numericId)}
                                    target='_blank'
                                    rel='noreferrer'
                                >
                                    Event name: <b>{event.name}</b>
                                </a>
                            </EventDetails>
                            <EventDetails>
                                Id: <b>{event.numericId}</b>
                            </EventDetails>
                            <EventDetails>
                                IdV2: <b>{event.id}</b>
                            </EventDetails>
                        </EventWrapper>
                    );
                })}
            </EventsWrapper>
            <AutomationPopupControlsContainer>
                <Button
                    size='regular'
                    onClick={props.popupState.close}
                >
                    Close
                </Button>
            </AutomationPopupControlsContainer>
        </AutomationPopupContainer>
    );
});
